import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  closeButton: {
    marginLeft: '8px',
    '& .MuiSvgIcon-root': {
      marginRight: '0px',
    },
  },
  dialogPaper: {
    overflow: 'visible',
    margin: 'auto',
  },
  dialogContent: {
    overflow: 'visible',
  },
  formLabel: {
    marginBottom: '4px',
    fontSize: '16px',
    fontWeight: foundations.typography.fontWeight.medium,
  },
  storiesListBlock: {
    display: 'flex',
    width: '100%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    alignItems: 'center',
    marginBottom: '16px',
  },
  storiesList: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flexShrink: 1,
    marginLeft: '4px',
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
  },
  radioButton: {
    alignItems: 'flex-start',
    '& input[type="radio"]': {
      display: 'none',
    },
  },
  spacer: {
    marginTop: '16px',
  },
  locationSelectContainer: {
    paddingTop: '8px',
  },
  dialogActions: {
    justifyContent: 'flex-end',
    gap: '8px',
    padding: '16px 24px',
  },
});
